<template>
  <div class="headinfo" v-if="info">
    <van-row class="van-hairline--bottom">
      <van-col
        span="15"
        class="flex aic van-hairline--right"
        style="height: 100%"
        ><div class=" ml-10">
          <!-- <img :src="info && info.avatarPath | getavatar" alt="" /> -->
          <van-image :src="info.avatarPath | getavatar" class="avater" round>
            <template v-slot:error>
              <img
                src="../../../assets/img/avater.png"
                class="avater"
                style="margin-top: 0"
              />
            </template>
          </van-image>
        </div>
        <div class="ml-15">
          <div class="flex aic">
            <div class="f1010 f16 nickname van-ellipsis">
              {{ info.alias?info.alias:info.nickName }}
            </div>
            <div class="f10 cl99 ml-15 virtualJob van-ellipsis">
              {{ info.virtualJob }}
            </div>
          </div>
          <div class="f12 cl99 mt-5 lh16">
            {{ info.dept && info.dept.name }} | 从业{{ info.workingSeniority }}
          </div>
        </div>
      </van-col>
      <van-col span="3" class="van-hairline--right tac" @click="getqrcode">
        <img src="../../../assets/img/card/weiixn.png" alt="" class="imgs" />
        <p class="f10 f1010">微信</p>
      </van-col>
      <van-col span="3" class="van-hairline--right tac" @click="phone">
        <img src="../../../assets/img/card/dianhua.png" alt="" class="imgs" />
        <p class="f10 f1010">电话</p>
      </van-col>
      <van-col span="3" class="tac" @click="todetail">
        <img src="../../../assets/img/card/mingpian.png" alt="" class="imgs" />
        <p class="f10 f1010">名片</p>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import Vue from "vue";
import { Col, Info, Row } from "vant";

Vue.use(Col);
Vue.use(Row);
export default {
  data() {
    return {};
  },
  props: ["info"],
  methods: {
    phone() {
      window.location.href = "tel:" + this.info.phone;
    },
    todetail() {
      this.$router.push({ path: "/usercard", query: { userId: this.info.id } });
    },
    getqrcode() {
      this.$emit("getqr");
    },
  },
};
</script>
<style lang="less" scoped>
.headinfo {
  width: 100%;
  height: 77px;
  border: 1px solid rgba(244, 244, 244, 100);
  padding-top: 8px;
  .avater {
    // img {
      width: 45px;
      height: 45px;
      border-radius: 100px;
      margin-top: 5px;
      border: 5px solid rgba(232, 228, 228, 100);
    // }
  }
  .imgs {
    width: 24px;
    height: 24px;
    margin-top: 14px;
    margin-bottom: 5px;
  }
  .lh16 {
    height: 16px;
  }
  .nickname {
    max-width: 70px;
    line-height: 24px;
  }
  .virtualJob {
    max-width: 70px;
    line-height: 16px;
  }
}
</style>